
import { Users } from "lucide-react";

export function PatientListEmpty() {
  return (
    <div className="text-center py-8 text-gray-500">
      <Users className="w-12 h-12 mx-auto mb-4 text-gray-300" />
      <p>No patients found</p>
    </div>
  );
}
